module.exports = __webpack_public_path__ + "img/instagram-post.ce15112e.png";